import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { caratDownBlueberry, caratDownBlueberryDark } from '../../../util/icons';
import { Text } from '../../../util/typography';
import * as colors from '../../../util/colors';
import Link from 'gatsby-link';

const MenuLabel = styled(Text.Button)`
    line-height: 1.13;
    flex: 0 auto;
    color: inherit;
`;

const StyledMenuLink = styled(Link).withConfig({
    shouldForwardProp: prop => !['hasChildren', 'isOpen', 'inActivePath', 'activePath', 'navType', 'hrefValue', 'brandType'].includes(prop),
})`
    padding: 1em 1em 0;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 100%;
    justify-content: center;
    text-decoration: none;
    color: ${({ level }) => (level === '1' ? colors.charcoal : colors.blueberry)};
    align-items: center;
    background-color: ${colors.white};
    transition: background-color 0.3s ease-in-out;
    box-sizing: border-box;
    height: 100%;
    z-index: 1;
    border: none;
    cursor: pointer;

    &:hover {
        background-color: ${colors.mist};
    }

    ${({ level, hasChildren, isOpen, hrefValue, brandType }) =>
        level === '1' && `
        background-color: ${isOpen ? colors.mist : 'none'};
        position: relative;
        
        &::after {
            display: block;
            content: "";
            margin-top: 6px;
            width: 10px;
            height: 20px;

            // background-image: url(${caratDownBlueberry});
            // ${hasChildren ? `background-image: url(${caratDownBlueberry});` : ''}
            background-size: contain;
            background-repeat: no-repeat;
            background-position-y: ${isOpen ? 'calc(100% + 10px)' : '0'};
            background-position-x: center;
            transition: background-position-y .3s ease-in-out;

           ${hasChildren || (hrefValue && hrefValue.startsWith('#'))
            ? `background-image: url(${caratDownBlueberry});`
            : ''
        }
        }
        &:hover {
        ${(brandType !== "keytrudahcp" && !hasChildren) && `
            &::after {
            animation-duration: 0.3s;
            animation-name: menu-arrowDown-animation;
            animation-fill-mode: both;

            ${hasChildren || (hrefValue && hrefValue.startsWith('#'))
            ? `background-image: url(${caratDownBlueberryDark});`
            : ''
    }

    @keyframes menu-arrowDown-animation {
        0% {
            background-position: center top;
        }
        50% {
            background-position: center calc(50% + 20px);
        }
        50.001% {
            background-position: center calc(50% - 20px);
        }
        100% {
            background-position: center top;
        }
        }
            `}
        }

        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 3px;
            background-color: transparent;
            bottom: -3px;
            transition: background-color .3s ease-in-out;
        }

        &.active {
            background-color: ${colors.mist};
            color: ${colors.blueberry};
            &:before {
                background-color: ${colors.keytrudaGreen};
            }
        }
        &:hover {
            &::after{
                ${hasChildren ? `background-image: url(${caratDownBlueberryDark});` : ''}
            }
        }
    `}

    ${({ inActivePath }) =>
        inActivePath && `
        color: ${colors.blueberry};
        background: ${colors.mist};
        &:before {
            background-color: ${colors.keytrudaGreen};
        }
    `}

    ${({ level, navType }) =>
        level === '2' && navType === 'topNav' &&
        `
        &.active {
           background: ${colors.mist};
        }`}
`;

const MenuLink = props => {
    //workaround for the fact that Gatsby Link doesn't seem to allow you to pass it's active class to a non-link (like our spans)
    let [inActivePath, setInActivePath] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.origin !== 'null') { //check to avoid errors in Gatsby build and in DSM's sandboxed iframe
            setInActivePath(window.location.pathname.startsWith(props.activePath));
        }
    }, [props.activePath])

   const isHashLink = props.url?.startsWith('#') || props.url?.startsWith('http');
   
    const linkProps = {
        as: props.hasChildren ? 'button' : undefined,
        to: !isHashLink ? props.url : undefined,
        href: isHashLink ? props.url : undefined,
        hrefValue: props.url,
        brandType: props.brandType,
        inActivePath: inActivePath,
        'data-design-category': 'top_nav_vd',
        ...props
    };

    //avoid errors for adding Link props to non-links (eg the parent spans)
    // if (!props.hasChildren) {
    //     linkProps.activeClassName = 'active';
    // }
    if (!props.hasChildren && !isHashLink) {
        linkProps.activeClassName = 'active';
    }

    return (
        <StyledMenuLink {...linkProps}>
            <MenuLabel dangerouslySetInnerHTML={{ __html: props.label }} />
        </StyledMenuLink>
    );
};
export default MenuLink;
